import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { computeDiscountPercentage } from "@app/shared/helpers/price";
import { Plan } from "@app/shared/models/plan";
import { PriceFormaterPipe } from "@app/shared/pipes/price-formater.pipe";
import { GetPlanGroupOutput } from "@smash-sdk/billing/ejs/01-2024";
import { ListCountriesOutput } from "@smash-sdk/vat/ejs/10-2019";
import moment from "moment";
import { extractDuration } from "smash-time";

@Component({
    selector: 'app-smash-signup-summary',
    templateUrl: './smash-signup-summary.component.html',
    styleUrls: ['./smash-signup-summary.component.scss']
})
export class SmashSignupSummaryComponent implements OnInit {
    @Input() computedPlan: Plan;
    @Input() selectedPlan: GetPlanGroupOutput['group']['plans'][0];
    @Input() plans: GetPlanGroupOutput['group']['plans'];
    @Input() language: string;
    @Input() selectedCountry: ListCountriesOutput['countries'][0];
    @Input() countries: ListCountriesOutput['countries'];
    smashPremium2years: GetPlanGroupOutput['group']['plans'][0];
    smashPremium1years: GetPlanGroupOutput['group']['plans'][0];
    smashPremium1month: GetPlanGroupOutput['group']['plans'][0];
    sale1year: number;
    sale2years: number;

    @Output() onSelectPlan: EventEmitter<any> = new EventEmitter<any>();
    constructor() { }

    ngOnInit(): void {
        this.smashPremium2years = this.plans.find(plan => plan.currency === this.selectedCountry.currency && plan.duration === '2years');
        this.smashPremium1years = this.plans.find(plan => plan.currency === this.selectedCountry.currency && plan.duration === '1years');

        if (this.smashPremium2years) {
            this.setSmashPremium1Month();
            this.sale1year = computeDiscountPercentage({ plan: this.smashPremium1years, countryCurrency: this.selectedCountry.currency, plans: this.plans });
            this.sale2years = computeDiscountPercentage({ plan: this.smashPremium2years, countryCurrency: this.selectedCountry.currency, plans: this.plans });
        }
    }

    selectOffer(offerDuration) {
        this.onSelectPlan.emit({ offerDuration, currency: this.selectedCountry.currency })
    }

    setSmashPremium1Month() {
        this.smashPremium1month = this.plans.find(plan => {
            const { quantity, unit } = extractDuration(plan.duration);
            return quantity === 1 && (unit === "month" || unit === "months") && plan.currency === this.selectedCountry.currency;
        });
    }

    get startingPrice() {
        this.setSmashPremium1Month();
        if (this.smashPremium1month) {
            const { quantity, unit } = extractDuration(this.selectedPlan.duration);
            const months = moment.duration(quantity, unit).asMonths();
            return this.smashPremium1month.priceExclTax * months;
        }
        return this.selectedPlan.priceExclTax;
    }

    get priceFormatted() {
        const { currency } = this.selectedPlan;
        const priceFormater = new PriceFormaterPipe();
        const { quantity, unit } = extractDuration(this.selectedPlan.duration);
        const months = moment.duration(quantity, unit).asMonths();
        const offer = this.selectedPlan.priceExclTax / months;
        return priceFormater.transform(offer, { language: this.language, currency });
    }

    get smashPremiumDiscount() {
        if (this.smashPremium1month) {
            return computeDiscountPercentage({ plan: this.selectedPlan, countryCurrency: this.selectedCountry.currency, plans: this.plans });
        }
        return 0;
    }
}